import React from 'react';
import {random_decimal, random_integer} from '../utils/random.js';
import {px_to_em, em_to_px} from '../utils/conversions.js';
import {slope, orient} from '../utils/rotations.js';

class Ship extends React.Component {
  constructor(props) {
    super(props);
    const quadrant = random_decimal();
    const orientation = orient(quadrant, this.props.bounds.width, this.props.bounds.height);
    const size = random_integer(5, 100);
    const speed = 0.01+(1-Math.log(size)/Math.log(100))*0.25;
    this.state = { 
      id: this.props.id,
      number: random_integer(0, 998),
      size : size,
      speed: speed,
      step: slope(orientation.r),
      rotation: orientation.r,
      position: {
        x: orientation.x,
        y: orientation.y
      }
    };
  }

  out_of_bounds() {
    let x = em_to_px(this.state.position.x);
    let y = em_to_px(this.state.position.y);
    return (x < -500) || (x > this.props.bounds.width+500) || (y < -500) || (y > this.props.bounds.height+500);
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState({ 
        position: {
          x: this.state.position.x+(this.state.speed*this.state.step.x),
          y: this.state.position.y+(this.state.speed*this.state.step.y)
        }
      });
      if (this.out_of_bounds()) {
        this.props.tools.rmv_ship(this.props.id);
        this.props.tools.add_ship();
      }
    }, 15);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const src = "./assets/"+this.state.number+".png";
    const size = this.state.size+"px";
    const style_position = {position: "absolute", left: this.state.position.x+"em", top: this.state.position.y+"em"};
    const style_rotation = {transform: "rotate("+this.state.rotation+"deg"+")"};
    return (
      <div 
        className="Ship"
        style={style_position} 
        onMouseEnter={() => this.props.tools.dsc_ship(this.state.number)} 
        onMouseLeave={() => this.props.tools.dsc_ship(false)}>
        <div className="Number">{"No. "+this.state.number}</div>
        <div style={style_rotation} className="ShipContainer">
          <img src={src} width={size} height={size} alt=""/>
        </div>
      </div>
    );
  }
}

export default Ship;